"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EnhancedTableToolbar;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _ = require(".");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
function EnhancedTableToolbar(props) {
  const {
    isAllSelected,
    numSelected,
    renderNumSelectedText,
    topBarButtons,
    topBarSelectionConfig
  } = props;
  const theme = (0, _material.useTheme)();
  const selectLinkStyles = {
    color: theme.palette.TwClrTxtBrand,
    cursor: 'pointer'
  };
  const topBarSelection = (0, _react.useMemo)(() => {
    if (!renderNumSelectedText) {
      return null;
    }
    if (!topBarSelectionConfig) {
      return renderNumSelectedText(numSelected);
    }
    const {
      handleSelectAll,
      handleSelectNone,
      renderSelectAllText,
      renderSelectNoneText,
      renderEnhancedNumSelectedText
    } = topBarSelectionConfig;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderEnhancedNumSelectedText ? renderEnhancedNumSelectedText() : renderNumSelectedText(numSelected), ' ', !isAllSelected && handleSelectAll && renderSelectAllText && /*#__PURE__*/_react.default.createElement(_material.Link, {
      onClick: handleSelectAll,
      sx: selectLinkStyles
    }, renderSelectAllText()), isAllSelected && handleSelectNone && renderSelectNoneText && /*#__PURE__*/_react.default.createElement(_material.Link, {
      onClick: handleSelectNone,
      sx: selectLinkStyles
    }, renderSelectNoneText()));
  }, [renderNumSelectedText, topBarSelectionConfig, numSelected]);
  return renderNumSelectedText && numSelected > 0 ? /*#__PURE__*/_react.default.createElement(_material.Toolbar, {
    sx: {
      background: theme.palette.TwClrBgSecondary,
      borderRadius: theme.spacing(0.5)
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "subtitle1",
    component: "div",
    sx: {
      flex: '1 1 auto'
    }
  }, topBarSelection), topBarButtons === null || topBarButtons === void 0 ? void 0 : topBarButtons.map((tbButton, index) => (0, _.isTopBarButton)(tbButton) ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: tbButton.tooltipTitle,
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    key: tbButton.buttonText,
    label: tbButton.buttonText,
    priority: "secondary",
    type: tbButton.buttonType,
    onClick: tbButton.onButtonClick,
    icon: tbButton.icon,
    disabled: tbButton.disabled,
    sx: {
      marginLeft: theme.spacing(1)
    }
  })) : tbButton)) : null;
}